import { popupName } from 'constants/auth/auth-data'

const AdditionPageTitle = {
  [popupName.registration]: 'Авторизация',
  [popupName.registration]: 'Регистрация',
}

const LoginHashPopup: Array<string> = [popupName.registration]

export { AdditionPageTitle, LoginHashPopup }
